import * as React from 'react';

// This component provides a custom implementation of the MailShield icon
// based on the official Fluent UI System Icons repository
// Source: https://github.com/microsoft/fluentui-system-icons
export const MailShield24Regular: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 2.62a4.06 4.06 0 0 1-1-.27 5.16 5.16 0 0 1-1.72-1.23.39.39 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77A5.5 5.5 0 0 0 12.01 9c.27.37.6.7.99 1 .52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V3a.4.4 0 0 0-.4-.33c-.2 0-.4-.02-.6-.05ZM10 4H4.5A2.5 2.5 0 0 0 2 6.5v8A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-4.03c-.3.27-.64.52-1 .74v3.29c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 14.5V7.96l6.75 3.97.08.04c.14.05.3.04.42-.04l2.05-1.2a6.05 6.05 0 0 1-.76-.72l-1.54.91L3 6.8v-.3C3 5.67 3.67 5 4.5 5H10V4Z" 
        fill="currentColor" />
    </svg>
  );
};
